import React from 'react';

const ContentGuidelines = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-sm text-gray-700">
      <h1 className="text-3xl font-bold mb-6">
        Linee Guida Contenuti
      </h1>

      <p className="mb-6">
        Per mantenere DealRadar sicuro e affidabile, tutti gli utenti devono
        rispettare le seguenti regole.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">
        Contenuti vietati
      </h2>

      <ul className="list-disc pl-6 space-y-2">
        <li>Prodotti illegali o contraffatti</li>
        <li>Armi, droga o sostanze vietate</li>
        <li>Materiale pornografico o violento</li>
        <li>Truffe o schemi fraudolenti</li>
        <li>Spam o pubblicità ingannevole</li>
        <li>Vendita senza autorizzazioni richieste dalla legge</li>
        <li>Documenti falsi o materiale rubato</li>
        <li>Violazioni di copyright o marchi registrati</li>
        <li>Dati personali pubblicati senza consenso</li>
        <li>Contenuti discriminatori o offensivi</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3">
        Moderazione
      </h2>

      <p className="mb-4">
        DealRadar può rimuovere contenuti, limitare account o sospendere utenti
        che violano le regole della piattaforma.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">
        Segnalazioni
      </h2>

      <p className="mb-4">
        Gli utenti possono segnalare contenuti sospetti o non conformi.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">
        Collaborazione con autorità
      </h2>

      <p className="mb-4">
        In presenza di attività illegali, DealRadar si riserva il diritto di
        collaborare con le autorità competenti.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">
        Contatti
      </h2>

      <p>
        support@dealradarapp.it
      </p>
    </div>
  );
};

export default ContentGuidelines;